import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=73c6dded&scoped=true"
import script from "./SignUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=73c6dded&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c6dded",
  null
  
)

export default component.exports